import React, { useEffect } from 'react'
import Skeleton from 'react-loading-skeleton'
import NewsSlider from '../components/NewsSlider'
import { Link } from 'react-router-dom'
import { BlocksRenderer } from '@strapi/blocks-react-renderer'

const Aktuelles = ({shortTitle, title, text, aktuelles}) => {
    useEffect(() => {
        console.log('test', aktuelles[0]);
    }, [aktuelles])
    return (
        <div>
            <div className='subtitle'>{shortTitle}</div>
            <div className='row mb-lg-5 mb-4 eql_col_content'>
                <div className='col-lg-5 title-col'>
                    <h2 className='text-black'>{title}</h2>
                </div>
                <div className='col-lg-7 content-col mt-3 mt-lg-0'>
                    {text && <BlocksRenderer content={text} />}
                </div>
            </div>
            <NewsSlider aktuelles={aktuelles} />

            <div className='btn-container justify-content-center mt-4 mt-lg-5'>
                <Link to="/aktuelles" className='button round_btn fill-theme-color'>
                    Alle News
                    <span>
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.7733 15.4513C20.7593 16.0532 20.2599 16.5526 19.6579 16.5667C19.056 16.5807 18.5794 16.1041 18.5934 15.5021L18.9037 2.20548L5.60703 2.51577C5.00507 2.52982 4.52846 2.05321 4.54251 1.45125C4.55657 0.849296 5.05594 0.349907 5.6579 0.33586L20.0445 0.000170705C20.6465 -0.0138708 21.1231 0.462731 21.109 1.06469L20.7733 15.4513Z" fill="inherit" />
                            <path d="M1.84309 20.7715C1.40751 21.2071 0.717391 21.2232 0.301672 20.8075C-0.114047 20.3918 -0.0979427 19.7017 0.337642 19.2661L19.2663 0.337392C19.7019 -0.0981931 20.3921 -0.114298 20.8078 0.301422C21.2235 0.717141 21.2074 1.40726 20.7718 1.84284L1.84309 20.7715Z" fill="inherit" />
                        </svg>
                    </span>
                </Link>
            </div>
        </div>
    )
}

export default Aktuelles